import { useState, useEffect } from 'react';
import type { SourceMessage } from '../../types/Tasks/sourceMessage';
import type { Task } from 'js-sdk/src/types/Tasks';

export type UseSourceMessageResult = {
  message: SourceMessage | undefined;
  isUnavailable: boolean;
  isLoading: boolean;
};

export function useSourceMessage(
  task: Task | null,
  findMessage: (id: string) => Promise<SourceMessage | undefined>
): UseSourceMessageResult {
  const [message, setMessage] = useState<SourceMessage | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isUnavailable, setIsUnavailable] = useState(false);

  const messageId = task?.source_type === 'message' ? task.source_ref.message_id : undefined;

  useEffect(() => {
    if (!messageId) {
      setMessage(undefined);
      setIsUnavailable(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    findMessage(messageId)
      .then((found) => {
        if (cancelled) return;
        setMessage(found);
        setIsUnavailable(!found);
        setIsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setIsUnavailable(true);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [messageId, findMessage]);

  return { message, isUnavailable, isLoading };
}
